import { Suspense, lazy } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute, useAuth } from '../../../../shared/ui';
import { UserRole } from '../../../../shared/utils/types';
import { NotFoundPage } from '../../pages/NotFoundPage';

const AdminRewardPointsPage = lazy(() =>
  import('../../pages/admin/AdminRewardPointsPage').then(m => ({
    default: m.AdminRewardPointsPage,
  }))
);

const ProtectedAdminRewardPointsPage = () => {
  const { user } = useAuth();
  if (user?.role !== UserRole.ADMIN) return <NotFoundPage />;
  return (
    <ProtectedRoute>
      <Suspense fallback={<div>Loading...</div>}>
        <AdminRewardPointsPage />
      </Suspense>
    </ProtectedRoute>
  );
};

export const Route = createFileRoute('/admin/reward-points')({
  component: ProtectedAdminRewardPointsPage,
});
